import { z } from 'zod';
import { CateringEventModelSchema } from 'entities/catering-event';
import { GetCateringEventBySlugApiResponseSchema } from '../store';

export const createCateringEventFromGetCateringEventBySlugApiResponse = (
    (response: z.infer< typeof GetCateringEventBySlugApiResponseSchema>) => (
        CateringEventModelSchema.parse({
            uid: response.data?.[0].slug,
            slug: response.data?.[0].slug,
            name: response.data?.[0].name,
            description: response.data?.[0].description,
            images: response.data?.[0].images?.map(({ url }) => ({
                url,
            })),
            format: response.data?.[0].format && ({
                name: response.data?.[0].format.name,
            }),
        })
    )
);
